import { LOGIN, LOGOUT } from '../type';
import axiosInstance from '../../config/axios.config';
import { initOptionsFromServer } from '../../redux/actions/options.action';
import { addError } from './error.action';
import { getTranslations } from '../../utils/getTranslations';
import translations from '../../content/Error/error.json';

export const loginUser = (options) => ({
  type: LOGIN,
  payload: options,
});

export const clearLoginError = () => ({
  type: 'CLEAR_LOGIN_ERROR',
});
export const resetPassword = (payload) => async (dispatch) => {
  const headers = {
    'Skip-Interceptor': 'true', // Указываем, что интерцепторы должны пропустить этот запрос
  };
  try {
    const response = await axiosInstance.post('/api/auth/forgot-password', payload, { headers });
    if (response?.status === 201) {
      return true;
    }
  } catch (e) {
    console.log(e);
    dispatch(logoutUser({ error: e?.response?.data?.message, logout: true }));
    return;
  }
};

export const login = (payload) => async (dispatch) => {
  const headers = {
    'Skip-Interceptor': 'true', // Указываем, что интерцепторы должны пропустить этот запрос
  };
  try {
    const response = await axiosInstance.post('/api/auth/signin', payload, { headers });
    if (response?.status === 200) {
      const isUserOk = !!response?.data?.roles?.length;
      const user = {
        user: isUserOk,
        role: response?.data?.roles,
        error: !isUserOk,
        logout: !isUserOk,
        fullName: response?.data?.name,
        position: response?.data?.position,
        accessToken: response?.data?.accessToken,
        refreshToken: response?.data?.refreshToken,
      };
      localStorage.setItem('accessToken', user?.accessToken || '');
      localStorage.setItem('refreshToken', user?.refreshToken || '');
      localStorage.setItem('role', user?.role?.join(',') || '');
      dispatch(loginUser(user));
      //поучаем опции для селектов
      dispatch(initOptionsFromServer());
    }
  } catch (e) {
    console.log(e);
    const t = getTranslations(translations);
    if (e?.message === 'Request failed with status code 502') {
      dispatch(
        addError({ error: t?.serverTemporaryError || 'Временная ошибка сервера. Пожалуйста, попробуйте позже.' })
      );
    }
    dispatch(logoutUser({ error: e?.response?.data?.message, logout: true }));
    return;
  }
};

export const logout = (options) => ({
  type: LOGOUT,
  payload: options,
});

export const logoutUser =
  (options) =>
  (dispatch, getState, { socket }) => {
    if (socket.connected) {
      socket?.disconnect();
    }
    dispatch(logout(options));
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('role');
    localStorage.removeItem('id');
  };
